// extracted by mini-css-extract-plugin
export default {"grid":"Grid_grid__FRZJ9","content":"Grid_content__SWIlx","cell":"Grid_cell__unUBF","classicGrid":"Grid_classicGrid__1M2pV"};